import { StopWatch } from "../StopWatch";

const Stopwatches = ({ 
    timestamp_groups = [],
    content_group 
}) => {
    return (
        <div className="stopwatches-container">
            {timestamp_groups.map((timestamp_group, index) => (
                <StopWatch
                    key={`stopwatch-` + index}
                    initialTime={timestamp_group?.total_seconds}
                    initialStartDate={timestamp_group?.latest_start}
                    isActive={content_group?.stage?.enable_timestamp && !content_group?.stage?.approved}
                />
            ))}
        </div>
    );
};

export { Stopwatches };